import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// localStorage.getItem('user')
export const PrivateRoute = ({ component: Component, token, ...rest }) => (
    <Route {...rest} render={props => (
        token
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
)
export default PrivateRoute;